<template>
	<div
		class="d-flex flex-row nowrap justify-content-md-between px-md-0 mx-md-0"
		id="details-top"
	>
		<div class="d-flex flex-column nowrap w-100 col-12 px-0">
			<div
				class="mb-3 mb-md-2 me-0 me-md-2 d-flex flex-row flex-nowrap d-lg-flex"
			>
				<div
					:class="['d-lg-flex flex-row nowrap align-items-md-center text-start me-2 w-100 position-relative', !isMobile() ? 'row' : '']"
				>
					<h3 :class="['heading text-grey-900 me-2 mb-0', !isMobile() ? 'col-10' : '']">
						<span class="w-100">
							<span>
								<template v-if="isDisplayPlaceholders">
									<PlaceholderBox
										:height="'25px'"
										:width="'300px'"
										:additionalClasses="'mb-2'"
									/>
								</template>
								<template v-else>
									{{ props.prestation.accomodationName }}
								</template>
							</span>
							<!-- <span class="caption text-grey-700 text-nowrap mt-2">
								<template v-if="isDisplayPlaceholders">
									<PlaceholderBox :height="'25px'" :width="'100px'" />
								</template>
								<template 
								v-if="!isDisplayPlaceholders 
								&& props.prestation.variants 
								&& !isPierreVacance(props.prestation.variants[0])"
								> 
									Ref: {{ reference }} 
								</template>
							</span> -->
						</span>
					</h3>
					<div
						:class="['d-none d-md-flex justify-content-center position-absolute more-info-button-container', !isMobile() ? 'col-2' : '']"
					>
						<div
							class="cursor-pointer plus-d-infos-hanging-btn-wrapper bg-white box-shadow"
						>
							<button
								class="button-secondary bg-none border-primary-blue text-primary-blue"
							>
								<div class="text-nowrap">
									<template v-if="isDisplayPlaceholders">
										<PlaceholderBox
											:height="'25px'"
											:width="'100px'"
										></PlaceholderBox>
									</template>
									<template v-else>
										{{ store.state.content.planner_prestationsMoreInfo }}
									</template>
								</div>
							</button>
						</div>
					</div>
				</div>
			</div>
			<PrestationPictureMobile
				@plusInfosClick="handlePlusDinfosClick"
				:isDisplayPlaceholders="isDisplayPlaceholders"
				:src="image"
			/>
			<div class="d-flex flex-column justify-content-between mt-3">
				<div class="mb-2">
					<InfoIcons
						:isDisplayPlaceholders="isDisplayPlaceholders"
						:prestation="props.prestation"
					/>
				</div>
				<div v-if="props.prestation.variants && 
						!isPierreVacance(props.prestation.variants[0])" class="d-flex flex-row justify-content-between"
					>
					<div v-if="isDisplayPlaceholders" class="text-md-end me-md-4 mb-2">
						<LimitedAvailabilityMessage
							:isDisplayPlaceholders="isDisplayPlaceholders"
							:quantity="lowestQuantity"
						/>
					</div>
				</div>
			</div>
			<div
				v-if="
					props.prestation.variants 
				"
				class="mt-2"
			>
				<div class="d-flex flex-row nowrap text-grey-900 position-relative justify-content-between" v-if="isShortStay() && hasMultipleVariantsWithDifferentSkipass">
					<div class="d-flex">
						<span
							v-if="!isDisplayPlaceholders && store.state.packCode !== 'HS'"
							class="me-2 text-nowrap caption"
						>
							{{ store.state.content.planner_prestationsInclude }}
							<svg class="icon info-icon tf-icon-10 tf-icon-sm-20">
								<use xlink:href="#___icon___info"></use>
							</svg>
							:
							<PackageDetalisPopUp
								:top="'0'"
								:left="'0'"
								:radius="'5px'"
							>
								<span v-for="(content, content_i) in store.getters.packageInfoContent" :key="`${content[0]}-${content_i}}`">{{ content }}</span>
							
							</PackageDetalisPopUp>
						</span>
						<Inclus
							:isPierreVacance="
								props.prestation.variants &&
								isPierreVacance(props.prestation.variants[0])
							"
							:isDisplayPlaceholders="isDisplayPlaceholders"
							:variant="props.prestation.variants[0]"
						/>
					</div>
					<div v-if="isDisplayPlaceholders" class="text-md-end me-md-4">
						<LimitedAvailabilityMessage
							:isDisplayPlaceholders="isDisplayPlaceholders"
							:quantity="lowestQuantity"
						/>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="ts" setup>
import {
	defineProps,
	withDefaults,
	ref,
	Ref,
	computed,
	ComputedRef,
	onMounted,
} from "vue";

// Store
//import store from "@/vue/planning/store/store";

// Components
import PrestationPictureMobile from "@/vue/planning/components/result/prestation/pictureMobile.vue";
import LimitedAvailabilityMessage from "@/vue/planning/components/result/prestation/limitedAvailabilityMessage.vue";
import InfoIcons from "@/vue/planning/components/result/infoIcons.vue";
import PlaceholderBox from "@/vue/planning/components/common/placeholderBox.vue";
import Inclus from "@/vue/planning/components/result/prestation/inclus.vue";
import PackageDetalisPopUp from "@/vue/planning/components/result/prestation/packageDetalisPopUp.vue";

// Logic
import { isPierreVacance } from "@/vue/planning/logic/pv";
import { isCS } from "@/vue/planning/logic/cs";
import { isValidNewSkiPassPackages } from "@/vue/planning/logic/isValidNewSkiPassPackages";
import { isMobile } from '@/utils/utils';

// Types
import { Prestation } from "@/types";


import { useStore } from "vuex"
const store = useStore();

interface Props {
	prestation: Prestation;
	isDisplayPlaceholders: boolean;
}
interface Emits {
	(e: "plusInfosClick"): void;
}

const props = withDefaults(defineProps<Props>(), {
	prestation: {},
	isDisplayPlaceholders: false,
});
const emit = defineEmits<Emits>();

// computed
const reference = computed(() => {
	const variants = props.prestation.variants;
	if (!variants) return;

	if (variants[0]["pvFlex"]) {
		const nonFlexVariant = variants.find((prest: any) => {
			return prest.pvFlex === "nonflex";
		});

		return nonFlexVariant.prestIdSource;
	}

	return variants[0].prestIdSource;
});

const isHSProduct = computed(() => {
	return props.prestation.variants[0].codePackage === "HS";
});

const lowestQuantity = computed(() => {
	const variants = props.prestation.variants;
	if (!variants) return;
	variants.sort((a: any, b: any) => a.quantity - b.quantity);
	return variants[0].quantity;
});


const image: ComputedRef<string> = computed(() => {
	const images = props.prestation?.picturesAccomodation || [];
	if (images.length === 0) return "";

	const img = images[0];
	return (
		img["imgSmall"] ||
		img["imgMedium"] ||
		img["imgLarge"] ||
		img["imgXL"] ||
		img["img"] ||
		""
	);
});

const hasMultipleVariantsWithDifferentSkipass: ComputedRef<boolean> = computed(() => {
	const variants = props.prestation.variants;
	if (!variants || variants.length < 2) return false;
	
	// Check if there are variants with different skipass durations
	const skipassValues = new Set(variants.map((v: any) => v.skipass).filter(Boolean));
	return skipassValues.size > 1;
});

// methods
const handlePlusDinfosClick = () => {
	emit("plusInfosClick");
};

/**
 * Determines if the stay is considered short based on specific conditions.
 *
 * This function checks if the first variant meets the CS condition 
 * (i.e., if it is not a CS variant or if it is a CS variant and is Pierre Vacance).
 * It also checks if the ski pass conditions for the new ski pass pacakges are valid.
 *
 * @returns {boolean} True if both the CS condition and the ski pass condition are met, indicating a short stay, false otherwise.
 */
const isShortStay=():boolean=> {
	const variants = props.prestation.variants;
	const firstVariant = variants[0];

	const CScondition = (!isCS(firstVariant) || (isCS(firstVariant) && isPierreVacance(firstVariant)))
	const skiPassCondition = !isValidNewSkiPassPackages(variants)
	
	return (CScondition && skiPassCondition);
}

</script>

<style scoped>
.button-secondary {
	width: 145px;
}

.more-info-button-container {
	right: 0;
	top: 2px;
}

/* Handles packageDetailsPoup showing */
.info-icon:hover + .package-info-container {
	visibility: visible;
}

/* @media only screen and (max-width: 600px) {
	.availabilityMessageAndFlexFixTagConteinerForNoPV {
		flex-direction: column-reverse !important;
	}

	.availabilityMessageAndFlexFixTagConteinerForPV {
		flex-direction: column !important;
	}
} */
</style>
